import { createSlice } from "@reduxjs/toolkit";
import { initialFilter } from "../page/CampaignUIHelpers";

const initialCampaignState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  campaignForEdit: undefined,
  lastError: null,
  filters: initialFilter
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const campaignSlice = createSlice({
  name: "campaigns",
  initialState: initialCampaignState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getCampaignById
    campaignFetched: (state, action) => {
      state.actionsLoading = false;
      state.campaignForEdit = action.payload.campaignForEdit;
      state.error = null;
    },
    // findCampaign
    campaignsFetched: (state, action) => {
      const { total_items, items } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = items;
      state.totalCount = total_items;
    },
    // getAllCampaign
    campaignAllFetched: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.all = action.payload.all;
    },
    // createCampaign
    campaignCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.campaign);
    },
    // updateCampaign
    campaignUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map((entity) => {
        if (entity.id === action.payload.campaign.id) {
          return action.payload.campaign;
        }
        return entity;
      });
    },
    campaignFilter: (state, action) => {
      state.listLoading = false
      state.error = null
      state.filters = action.payload
    }
  },
});
